import { CONTENT_INNER_WIDTH, SORT_TYPES } from 'common/constants';
import styles from 'styles/table.css';
import tableHeaderStyles from 'styles/tableHeader.css';

// Setting defaults here because of Jest doesn't do all the magic webpack does with CSS Modules.
if (!tableHeaderStyles.ch) {
  tableHeaderStyles.ch = '49px';
}
if (!tableHeaderStyles.cf) {
  tableHeaderStyles.cf = '44px';
}
if (!tableHeaderStyles.hbb) {
  tableHeaderStyles.hbb = '1px';
}

export const DATE_WIDTH = 130;

export const PATIENT_TABLE_COLUMN_HEADERS = {
  PATIENT: 'patient',
  DOB: 'dob',
  SEX: 'sex',
  ORDERING_PHYSICIAN: 'orderingPhysician',
  CONNECTION_STATUS: 'connectionStatus',
  PRESCRIPTION: 'prescription',
  BILLING_CODE: 'billingCode',
  SUBJECT_ID: 'subjectID',
  STUDY_ID: 'studyID',
  SITE_IDENTIFICATION_NUMBER: 'siteIdentificationNumber',
};

export const TABLE_COLUMN_HEADER_WIDTH = {
  PATIENT: 160,
  DOB: 150,
  BILLING_CODE: 110,
  ORDERING_PHYSICIAN: 160,
  CONNECTION_STATUS: 140,
};

export const EXTRA_DEFAULT_COLUMN_WIDTH = {
  SUBJECT_ID: 140,
  STUDY_ID: 140,
  SITE_IDENTIFICATION_NUMBER: 140,
};

const DEFAULT_PRESCRIPTION_HEADER_WIDTH = 400;

const REAMAINING_COLUMN_HEADER_WIDTH =
  CONTENT_INNER_WIDTH -
  TABLE_COLUMN_HEADER_WIDTH.PATIENT -
  TABLE_COLUMN_HEADER_WIDTH.DOB -
  TABLE_COLUMN_HEADER_WIDTH.BILLING_CODE -
  TABLE_COLUMN_HEADER_WIDTH.ORDERING_PHYSICIAN -
  TABLE_COLUMN_HEADER_WIDTH.CONNECTION_STATUS;

TABLE_COLUMN_HEADER_WIDTH.PRESCRIPTION = Math.max(
  REAMAINING_COLUMN_HEADER_WIDTH,
  DEFAULT_PRESCRIPTION_HEADER_WIDTH,
);

export const TABLE_ROW_HEIGHT = 74;

export const TABLE_HEADER_HEIGHT =
  parseInt(tableHeaderStyles.ch.replace('px', ''), 10) +
  parseInt(tableHeaderStyles.cf.replace('px', ''), 10) +
  parseInt(tableHeaderStyles.hbb.replace('px', ''), 10);

export const TABLE_HEADER_HEIGHT_NO_FILTERS =
  parseInt(tableHeaderStyles.ch.replace('px', ''), 10) +
  parseInt(tableHeaderStyles.hbb.replace('px', ''), 10);

export const getNextSortDirection = currentSortDirection => {
  let nextSortDirection;

  // asc (default) -> desc -> asc -> repeat
  switch (currentSortDirection) {
    case SORT_TYPES.ASC:
      nextSortDirection = SORT_TYPES.DESC;
      break;
    case SORT_TYPES.DESC:
    default:
      nextSortDirection = SORT_TYPES.ASC;
      break;
  }

  return nextSortDirection;
};

export const getSelectedList = selected =>
  Object.keys(selected)
    .filter(id => selected[id] === true)
    .reduce((acc, id) => {
      acc.push(id);
      return acc;
    }, []);

export const getStripeRowStyle = ({ index }) => {
  let classname;

  if (index < 0) {
    classname = styles.headerRow;
  } else {
    classname =
      (index + 1) % 2 === 0
        ? `${styles.row} ${styles.evenRow}`
        : `${styles.row} ${styles.oddRow}`;
  }

  if (index !== -1) {
    classname += ` ${styles.clickableRow}`;
  }

  return classname;
};



// WEBPACK FOOTER //
// ./src/views/components/Table/utils.js